export const ActionTypes = {
    CHECK_FACET_OPTION: '@@search/facets/CHECK_FACET_OPTION',
    CLEAR_FACET_OPTIONS: '@@search/facets/CLEAR_FACET_OPTIONS',
    CLEAR_MANY_FACET_OPTIONS: '@@search/facets/CLEAR_MANY_FACET_OPTIONS',
    GEOLOCATION_COMPLETED: '@@search/geolocation/COMPLETED',
    RESET_FILTERS: '@@search/facets/RESET_FILTERS',
    SEARCH_COMPLETED: '@@search/search/COMPLETED',
    SEARCH_FAILED: '@@search/search/FAILED',
    SEARCH_STARTED: '@@search/search/STARTED',
    SELECT_FACET_OPTION: '@@search/facets/SELECT_FACET_OPTION',
    SET_SESSION_ID: '@@search/SET_SESSION_ID',
    SET_TRACKING_ID: '@@search/SET_TRACKING_ID',
    TRACK_FACET_CHIP_CLICK: '@@search/tracking/TRACK_FACET_CHIP_CLICK',
    TRACK_DOCTOR_CARD_CLICK: '@@search/tracking/TRACK_DOCTOR_CARD_CLICK',
    TRACK_SEARCH_REQUEST: '@@search/tracking/TRACK_SEARCH_REQUEST',
    TRACK_FILTER_ADDITIONAL_CRITERIA_CLICK: '@@search/tracking/TRACK_FILTER_ADDITIONAL_CRITERIA_CLICK',
    TRACK_FILTER_AVAILABILITY_CLICK: '@@search/tracking/TRACK_FILTER_AVAILABILITY_CLICK',
    TRACK_FILTER_HOSPITAL_AFFILIATIONS_CLICK: '@@search/tracking/TRACK_FILTER_HOSPITAL_AFFILIATIONS_CLICK',
    TRACK_FILTER_LANGUAGE_CLICK: '@@search/tracking/TRACK_FILTER_LANGUAGE_CLICK',
    TRACK_FILTER_SORT_MATCHES_CLICK: '@@search/tracking/TRACK_FILTER_SORT_MATCHES_CLICK',
    TRACK_FILTER_SPECIAL_HOURS_CLICK: '@@search/tracking/TRACK_FILTER_SPECIAL_HOURS_CLICK',
    TRACK_MAP_CLICK: '@@search/tracking/TRACK_MAP_CLICK',
    TRACK_MOBILE_MAP_TOGGLE_CLICK: '@search/TRACK_MOBILE_MAP_TOGGLE_CLICK',
    TRACK_MORE_FILTERS_CLICK: '@search/TRACK_MORE_FILTERS_CLICK',
    TRACK_PAGINATION_NUMBER_CLICK: '@@search/tracking/TRACK_PAGINATION_NUMBER_CLICK',
    TRACK_PPS_CHANGE: '@@search/tracking/TRACK_PPS_CHANGE',
    TRACK_PPS_CLICK: '@@search/tracking/TRACK_PPS_CLICK',
    TRACK_PPS_FOCUS: '@@search/tracking/TRACK_PPS_FOCUS',
    TRACK_PPS_SELECT: '@@search/tracking/TRACK_PPS_SELECT',
    TRACK_REFINE_SEARCH_CLICK_GENDER: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_GENDER',
    TRACK_REFINE_SEARCH_CLICK_PROCEDURE_DROPDOWN: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_PROCEDURE_DROPDOWN',
    TRACK_REFINE_SEARCH_CLICK_SPECIALTY_DROPDOWN: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_SPECIALTY_DROPDOWN',
    TRACK_REFINE_SEARCH_SELECT_PROCEDURE: '@@search/tracking/TRACK_REFINE_SEARCH_SELECT_PROCEDURE',
    TRACK_REFINE_SEARCH_SELECT_SPECIALTY: '@@search/tracking/TRACK_REFINE_SEARCH_SELECT_SPECIALTY',
    TRACK_REVIEWS_READ_MORE_TOGGLE: '@@search/tracking/TRACK_REVIEWS_READ_MORE_TOGGLE',
    TRACK_SEARCH_SCROLL_COUNT: '@@search/tracking/TRACK_SEARCH_SCROLL_COUNT',
    TRACK_SEARCH_SCROLLED_TO_RESULT: '@@search/tracking/TRACK_SEARCH_SCROLLED_TO_RESULT',
    TRACK_SEARCH: '@@search/tracking/TRACK_SEARCH',
    TRACK_SORTING_DROPDOWN_CLICK: '@@search/tracking/TRACK_SORTING_DROPDOWN_CLICK',
    TRACK_TIMESGRID_CLICK_MORE_TIMES: '@@search/tracking/TRACK_TIMESGRID_CLICK_MORE_TIMES',
    TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE: '@@search/tracking/TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE',
    TRACK_TIMESGRID_CLICK_NEXT_DAYS: '@@search/tracking/TRACK_TIMESGRID_CLICK_NEXT_DAYS',
    TRACK_TIMESGRID_CLICK_PHONE_NUMBER: '@@search/tracking/TRACK_TIMESGRID_CLICK_PHONE_NUMBER',
    TRACK_TIMESGRID_CLICK_PREV_DAYS: '@@search/tracking/TRACK_TIMESGRID_CLICK_PREV_DAYS',
    TRACK_TIMESGRID_CLICK_TIME_SLOT: '@@search/tracking/TRACK_TIMESGRID_CLICK_TIME_SLOT',
    TRACK_TIMESGRID_DATA_LOADED: '@@search/tracking/TRACK_TIMESGRID_DATA_LOADED',
    TRACK_TIMESGRID_LOADED: '@@search/tracking/TRACK_TIMESGRID_LOADED',
    UNCHECK_FACET_OPTION: '@@search/facets/UNCHECK_FACET_OPTION',
    UPDATE_PARAMETERS: '@@search/search/UPDATE_PARAMETERS',
    UPDATE_PENDING_PARAMETERS: '@@search/search/UPDATE_PENDING_PARAMETERS',
};
